import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
    templateUrl: './insights.view.html',
    styleUrls: ['./insights.style.scss'],
})
export class InsightsView implements OnInit, OnDestroy {
    isLoading = true;

    ngOnInit(): void {
        this.isLoading = false;
        $('body').addClass('data-bg');
    }

    ngOnDestroy(): void {
        $('body').removeClass('data-bg');
    }
}
